import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { mergeClasses } from '@griffel/react';

ReactModal.setAppElement('#root');

const UIWindowModal = ({ className, isOpen, onClose, children, hasClose = true }) =>
{
	const [isOverflow, setIsOverflow] = useState(false);

	useEffect(() =>
	{
		if (isOpen)
		{
			// Use setTimeout to ensure the modal is rendered and its dimensions are accessible
			const timer = setTimeout(() =>
			{
				const modalElement = document.querySelector('.ReactModal__Content');
				if (modalElement)
				{
					const isModalOverflowing = modalElement.offsetHeight > window.innerHeight;
					setIsOverflow(isModalOverflowing);
				}
			}, 0);

			return () => clearTimeout(timer);
		}
	}, [isOpen]);

	let portalClassName = mergeClasses(
		'modal-portal window-modal',
		className,
		isOpen ? 'is-opened' : '',
		isOverflow ? 'is-overflow' : ''
	);
	let overlayClassName = mergeClasses('modal-overlay window-modal', className);
	className = mergeClasses('modal window-modal', className);

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onClose}
			className={className}
			portalClassName={portalClassName}
			overlayClassName={overlayClassName}
			closeTimeoutMS={300}
		>
			{children}
			{hasClose && (
				<button className="icon-btn circle btn-close" onClick={onClose}>
					<p className="icon close" />
				</button>
			)}
		</ReactModal>
	);
};

export default UIWindowModal;
